import { Object, String, Static, Optional, Union, Array, Number } from '@sinclair/typebox';

export type Auth0Token = Static<typeof Auth0TokenSchema>;
export const Auth0TokenSchema = Object({
  token: String(),
  tokenType: String(),
  info: Optional(String()),
  rateLimit: Optional(String()),
  appName: Optional(String()),
  appId: Optional(String()),
  issuer: Optional(String()),
  audience: Optional(Union([String(), Array(String())])),
  issuedAt: Optional(Number()),
  expires: Optional(Number()),
  subscriptionKey: Optional(String()),
});
